import { CareConneSenderByStudent } from "@app/models/note.model";
import { KirokuSetting } from "@app/models/record-settig.model";
import { DisplaySetting, KirokuMenu, MenuParam, RecordList, RecordListType } from "@app/models/record.model";

export class SetSetting {
    static readonly type = '[Record] Set record list parameter';
    constructor(public menuParam: MenuParam, public daicd?: string) { }
}
export class SetDisplaySetting {
    static readonly type = '[Record] Set display setting parameter';
    constructor(public displaySetting: DisplaySetting) { }
}

export class ClearRecordList {
    static readonly type = '[Record] Set display setting parameter';
    constructor() { }
}
export class GetInitFacesheetList {
    static readonly type = '[Record] Store init record list';
    constructor(public recordList: RecordList) { }
}
export class RemoveInitFacesheetList {
    static readonly type = '[Record] Remove store init record list';
    constructor() { }
}

export class SetInitialRecordListSetting {
    static readonly type = '[Record] Set initial record list setting';
    constructor(public payload?: MenuParam & DisplaySetting & RecordListType, public daicd?: string) { }
}

export class SetListEnv {
    static readonly type = '[Record] Set ListEnv';
    constructor(public payload?: object | null) { }
}

export class SetListEnvXML {
    static readonly type = '[Record] Set ListEnvXML';
    constructor(public payload?: any) { }
}

export class ClearListEnvs {
    static readonly type = '[Record] Clear ListEnvs';
    constructor() { }
}

export class SetKirokuSetting {
    static readonly type = '[Record] Set kiroku setting';
    constructor(public setting?: KirokuSetting, public origin?: KirokuMenu) { }
}

export class CareConneSenderCreate {
    static readonly type = '[CareConne] sender create';
    constructor(public roomIds: number[], public message: string, public isMessageOptional?: boolean) { }
}

export class CareConneSenderEmpty {
    static readonly type = '[CareConne] sender empty';
    constructor() { }
}

export class CareConneSenderCreateByStudent {
    static readonly type = '[CareConne] sender create by student';
    constructor(public roomIds: number[], public message: string, public daicd?: string, public isMessageOptional?: boolean) { }
}

export class CareConneSendersCreateByStudent {
    static readonly type = '[CareConne] senders create by student';
    constructor(public senders: CareConneSenderByStudent[]) { }
}

export class CleanCareConneSendersCreateByStudent {
    static readonly type = '[CareConne] Clean up sender create by student';
}